import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import WritePopupContent from '../popup/write/index';
import ViewPopupContent from '../popup/view/index';
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import SearchArea from './area/search/search_area';
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import WriteFrameContent from "./area/write";

function ListPage() {
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>();
  const WriteFrameContentRef = useRef<any>();
  let default_list_opt = {
    's_start_date': DateFunc.get_date_format(new Date(), "Y-m-d"),
    's_end_date': DateFunc.get_date_format(new Date(), "Y-m-d"),
    "s_is_success_prescribe": "",
    "s_writer_seq": "",
    "s_subject_name": "",
    "s_addon_comment": "1",
  };
  if (strFunc.get_storage("s_stu_diary_period") == "this_month") {
    default_list_opt["s_start_date"] = DateFunc.get_date_format(new Date(), "Y-m-01");
    default_list_opt["s_end_date"] = DateFunc.get_date_format(new Date(), "Y-m-t");
  }
  const [pageData, setPageData] = useState({
    listOpt: {
      ...xColumnArr.list_opt,
      "s_addon_user":"1",
      "select_seq": "",
      ...default_list_opt
    }
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [is_open_write, set_is_open_write] = useState(true);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "write",//view
    isUpdate: false,
    rowData: {},
    stu_seq: "",
    stu_name: "",
    has_header: true,
    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: false,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
      tab_id: "study_and_counsel",
      is_first_tab_scroll: true,
      counsel_s_select_date: "",
    },
    title: "팝업",
    width: "800px",
    height: "80%",
  });
  let is_under_width = MyScreenFunc.get_is_under();

  useEffect(() => {
    if (is_under_width) {
      set_is_open_write(false);
    }
  }, []);

  const list = (inOptObj: any) => {
    let tmpPageData = pageData;
    if (inOptObj != undefined) {
      inOptObj["sc"] = listAggridRef.current.getListSc();
      for (let key in tmpPageData.listOpt) {
        if (inOptObj[key] != undefined) {
          tmpPageData.listOpt[key] = inOptObj[key];
        }
      }
      setPageData({ ...tmpPageData });
    }
    let tmp_list_opt = { ...tmpPageData.listOpt };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/study_diary/list', tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
          if (!strFunc.is_empty(tmp_list_opt.select_seq) && listAggridRef.current) {
            setTimeout(() => {
              let all_nodes = listAggridRef.current.getNodeRows();
              for (let i = 0; i < all_nodes.length; i++) {
                let row_node = all_nodes[i];
                let row_pri_val = row_node.data["a_ymd"] + "," + row_node.data["a_seq"];
                if (row_pri_val == tmp_list_opt.select_seq) {
                  row_node.setSelected(true);
                }
              }
            }, 100);
          }
        } else {

        }
      });
  };

  const goDelete = useCallback((e: any) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/study_diary/delete', form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          setWriteState();
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  }, []);

  const openOnePopup = (sort: string, isUpdate: boolean) => {
    let pop_title = "등록";
    let tmp_rowData = {};
    if (isUpdate) {
      pop_title = "수정";
      let selected_row = listAggridRef.current.getSelectedRows();
      if (selected_row.length == 0) {
        alert("선택이 없습니다.");
        return false;
      }
      if (selected_row.length > 0) {
        tmp_rowData = { ...selected_row[0] };
      }
    }
    if (sort == "view") {
      pop_title = "보기";
    }
    setPopupData({
      ...popupData,
      "isOpen": true,
      "isUpdate": isUpdate,
      "rowData": tmp_rowData,
      "title": pop_title,
      "sort": sort,
      width: "800px",
      height: "80%",
    });
  };

  const setWriteState = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length > 0) {
      listAggridRef.current.setSelectFalseAll();
    }
    if (WriteFrameContentRef.current) {
      WriteFrameContentRef.current.setInitData();
    }
    if (is_under_width) {
      set_is_open_write(true);
    }
  };
  const setWriteStateUpdate = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    if (selected_row.length != 1) {
      alert("한개만 선택해 주세요.");
      return false;
    }
    if (WriteFrameContentRef.current) {
      WriteFrameContentRef.current.setInitData({
        "row_data": selected_row[0],
        "isUpdate": "1"
      });
    }
    if (is_under_width) {
      set_is_open_write(true);
    }
  };

  const open_stu_layer_popup = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    if (selected_row.length != 1) {
      alert("한개만 선택해주세요.");
      return false;
    }
    let select_row_data = selected_row[0];
    if (strFunc.is_empty(select_row_data["stu_info"])) {
      alert("학생정보가 없습니다.");
      return false;
    }
    let select_idx = 0;
    let stu_info_arr: any = [select_row_data["stu_info"]];
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "원생관리",
      "sort": "stu_view",
      write_page_data: {
        is_show: true,
        is_update: true,
        is_view_mode: true,
        is_view_basic: false,
        select_idx: select_idx,
        info_arr: stu_info_arr,
        default_write_info: {},
        tab_id: "study_and_counsel",
        is_first_tab_scroll: true,
        counsel_s_select_date: select_row_data["a_study_date"].substring(0, 10),
      },
      width: "98%",
      height: "99%",
      has_header: false,
    });
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    if (key == "a_stu_name") {
      setTimeout(() => {
        open_stu_layer_popup();
      }, 100);
    }
  }, []);

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    let just_con_key_arr = [
      "a_study_goal",
      "a_observe",
      "a_study_prescribe",
    ];
    if(key=="a_stu_name"){
      if(params.data.stu_info){
        render_str=params.data.stu_info.a_user_name;
        render_str+=" "+params.data.stu_info.a_stu_total_code;;
      }
    }else if (key == "row_view_is_success_prescribe") {
      let col_text = "아니오";
      let col_style: any = {
        "color": "red",
      };
      if (params.data.a_is_success_prescribe == "1") {
        col_text = "완료";
        col_style["color"] = "blue";
      }
      render_str = (
        <span style={col_style}>{col_text}</span>
      );
    } else if (key == "a_prescribe_success_date") {
      if (params.data.a_is_success_prescribe != "1") {
        render_str = "";
      }
    } else if (key == "row_view_manage") {
      let content_detail_str="목표:\n";
      content_detail_str+=params.data.a_study_goal+"\n";
      content_detail_str+="관찰기록:\n";
      content_detail_str+=params.data.a_observe+"\n";
      content_detail_str+="학습처방:\n";
      content_detail_str+=params.data.a_study_prescribe+"\n";
      content_detail_str+="작성시간:"+params.data.a_create_date+"\n";
      if(params.data.a_is_success_prescribe=="1"){
        content_detail_str+="처방시간:"+params.data.a_prescribe_success_date+"\n";
      }

      render_str = (
        <div className="text-center">
          <button className="btn btn-dark"
            title={content_detail_str}
            onClick={() => {
              setTimeout(() => {
                open_stu_layer_popup();
              }, 100);
            }}>상세</button>
        </div>
      );
    } else if (strFunc.str_in_array(key, just_con_key_arr) != -1) {
      render_str = (
        <div title={params.value}>
          {params.value}
        </div>
      );
    } else if (key == "row_view_comment") {
      if (params.data.comment_arr && params.data.comment_arr.length > 0) {
        let last_comment_info = params.data.comment_arr[0];
        render_str = (
          <span title={last_comment_info["a_message"]}>
            {"(" + params.data.comment_arr.length + ") " + last_comment_info["a_message"]}
          </span>
        );
      }
    }
    return render_str;
  }, []);

  const onSelectionChanged = (event: any) => {
    let tmp_is_under = MyScreenFunc.get_is_under();
    if (tmp_is_under) {

    } else {
      let selected_row = listAggridRef.current.getSelectedRows();
      if (selected_row.length > 0) {
        if (selected_row.length == 1) {
          if (WriteFrameContentRef.current) {
            WriteFrameContentRef.current.setInitData({
              "row_data": selected_row[0],
              "isUpdate": "1"
            });
          }
        } else {
          if (WriteFrameContentRef.current) {
            WriteFrameContentRef.current.setInitData();
          }
        }
      } else {
        setWriteState();
      }
    }
  };

  return (
    <CompLayout isConTitle={false} >
      <div className="con_wrap">
        <SearchArea
          listOpt={{ ...pageData.listOpt }}
          xColumnArr={{ ...xColumnArr }}
          list={list}
        ></SearchArea>
        <div className="list_round_box_wrap mt-7">
          <div className="list_box_title_bar">
            <span className="list_box_title_bar_title">디스커버리</span>
            <div className="absolute right-3 top-4 btn-box-right">
              <button className="btn btn-sky" onClick={() => { openOnePopup("write", false); }}>신규</button>
              <button className="btn btn-dark" onClick={() => { openOnePopup("write", true); }}>수정</button>
              {/*
              <button className="btn-m btn-sky" onClick={() => { setWriteState(); }}>신규</button>
              <button className="btn-m btn-sky" onClick={() => { setWriteStateUpdate(); }}>수정</button>
               */}
              <button className="btn-m btn-red" onClick={goDelete}>삭제</button>
            </div>
          </div>
          <div className="list_round_box">
            <div className="flex flex-row gap-x-2">
              {/* <div className="grow" style={{ minWidth: 300, display: (is_under_width && is_open_write) ? "none" : "" }} >
                <WriteFrameContent
                  ref={WriteFrameContentRef}
                  list={(listOpt: any) => { list(listOpt); }}
                  set_is_open_write={(inData: boolean) => { set_is_open_write(inData) }}
                ></WriteFrameContent>
              </div> */}
              <div style={{ flexGrow: 1 }}>
                <ListAggrid
                  ref={listAggridRef}
                  infoArr={infoArr}
                  xColumnArr={{ ...xColumnArr }}
                  list={list}
                  gridOpt={{
                    fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
                    is_idx_num: false,
                    is_add_checkbox: true,
                    floatingFilter: false,
                    onGridReady: () => {
                      list({});
                    },
                    onCellClicked: cellClickedListener,
                    cellRenderer: cellRenderer,
                    onSelectionChanged: onSelectionChanged
                  }}
                ></ListAggrid>
                <Paging now_page={pageData.listOpt.now_page}
                  num_per_page={pageData.listOpt.num_per_page}
                  total_rec={countInfo.tot}
                  onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
                  onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
              </div>
            </div>
          </div>
        </div>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "write" &&
            <WritePopupContent isUpdate={popupData.isUpdate} rowData={popupData.rowData}
              callback={(inData: any) => { list({ now_page: 1, select_seq: inData.select_seq }); }}
              stu_seq={popupData.stu_seq}
              stu_name={popupData.stu_name}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></WritePopupContent>
          }
          {popupData.sort === "view" &&
            <ViewPopupContent isUpdate={popupData.isUpdate} rowData={popupData.rowData} callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              openOnePopup={openOnePopup}></ViewPopupContent>
          }
          {popupData.sort === "stu_view" &&
            <ViewStuLayerPopup
              write_page_data={popupData.write_page_data}
              is_first_tab_scroll={popupData.write_page_data.is_first_tab_scroll}
              callback={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewStuLayerPopup>
          }
        </LayerPopup>
      }
    </CompLayout>
  );
}

export default ListPage;